"use strict";
var InternalAzureLogger = require("./InternalAzureLogger");
var ENV_enableDebugLogging = "APPLICATION_INSIGHTS_ENABLE_DEBUG_LOGS";
var ENV_disableWarningLogging = "APPLICATION_INSIGHTS_DISABLE_WARNING_LOGS";
var Logging = /** @class */ (function () {
    function Logging() {
    }
    Logging.info = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.enableDebug) {
            InternalAzureLogger.getInstance().info(this.TAG + message, optionalParams);
        }
    };
    Logging.warn = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (!this.disableWarnings) {
            InternalAzureLogger.getInstance().warning(this.TAG + message, optionalParams);
        }
    };
    Logging.enableDebug = (process.env[ENV_enableDebugLogging]) ? true : false;
    Logging.disableWarnings = (process.env[ENV_disableWarningLogging]) ? true : false;
    Logging.TAG = "ApplicationInsights:";
    return Logging;
}());
module.exports = Logging;
//# sourceMappingURL=Logging.js.map